import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c68bdb2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c68bdb2')) {
      api.createRecord('2c68bdb2', component.options)
    } else {
      api.reload('2c68bdb2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c68bdb2", function () {
      api.rerender('2c68bdb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/power-plant-data/index.vue"
export default component.exports